import {ActionPlaceholder} from "@/utils/moreMenu/ActionHandler.ts";
import ActionPerformerHelper from "@/utils/moreMenu/ActionPerfomerHelper.ts";
import DTOFilledQuestionField = namaTypes.DTOFilledQuestionField;

export default abstract class ActionPerformer {
  abstract performAction(action: ActionPlaceholder, questionFields: DTOFilledQuestionField[]): Promise<void>;

  abstract isRecordNotSaved(): boolean;

  abstract runCustomAction(action: ActionPlaceholder): Promise<void>;

  abstract getSearchContextProvider(): ActionPerformerHelper | undefined;

  abstract calcDefaultsOf(action: ActionPlaceholder, callback: (fields: DTOFilledQuestionField[]) => void): void;

  editDashboardElements(): void {
  }

  editChartConfig(): void {
  }

  editMappings(): void {
  }

  abstract fetchLastTerminalPayTrnx(): Promise<void>;

  abstract payInvoice(value: number | undefined): Promise<void>;

  abstract signDocuments(onlySelected: boolean): Promise<void>;

  abstract readFirstWeight(): Promise<void>;

  abstract readSecondWeight(): Promise<void>;

  abstract showCurrentApprovalCase(): Promise<void>;

  async bulkEdit(action:ActionPlaceholder){}
}
